<template>
  <div
    class="store-icons w-full relative min-h-[87vh] md:max-h-none max-h-[87vh] flex items-center justify-center gap-8 md:flex-row flex-col"
    v-if="!redirected"
  >
    <a v-if="showIcons" :href="googlePlayLink" target="_blank" rel="noopener">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
        alt="Google Play Store"
        style="height: 60px"
      />
    </a>
    <a
      v-if="showIcons"
      :href="appleStoreLink"
      target="_blank"
      rel="noopener"
      style="opacity: 0.5; cursor: not-allowed"
      title="Coming Soon"
    >
      <img
        src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
        alt="Apple App Store"
        style="height: 60px"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "StoreIcons",
  props: {
    showIcons: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      googlePlayLink:
        "https://play.google.com/store/apps/details?id=com.korensi.qoray",
      appleStoreLink: "",
      redirected: false,
    };
  },
  mounted() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.location.href = this.googlePlayLink;
      this.redirected = true;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return null;
      window.location.href = this.appleStoreLink;
      this.redirected = true;
    }
  },
};
</script>

<style scoped>
/* Optional custom styles */
</style>
